const applyGoogleTranslateDomFix = () => {
  if (typeof window === 'undefined') return;
  if (window.__googleTranslateDomFixApplied) return;

  window.__googleTranslateDomFixApplied = true;

  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function removeChildPatched(child) {
    if (!child || child.parentNode !== this) {
      return child;
    }

    try {
      return originalRemoveChild.call(this, child);
    } catch (error) {
      if (error?.name === 'NotFoundError') {
        return child;
      }
      throw error;
    }
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function insertBeforePatched(newNode, referenceNode) {
    if (!referenceNode || referenceNode.parentNode === this) {
      return originalInsertBefore.call(this, newNode, referenceNode);
    }

    return this.appendChild(newNode);
  };
};

export { applyGoogleTranslateDomFix };
